import Icon from '@ant-design/icons';
import styled from 'styled-components';
import PorscheCloseIcon from '../../icons/porscheCloseIcon.svg';
import { CloseButtonCss } from '../default/CloseButton';
import LocalButton from './Button';

const Button = styled(LocalButton)`
    ${CloseButtonCss}
`;

const CloseButton = props => <Button {...props} icon={<Icon component={PorscheCloseIcon} />} />;

export default CloseButton;
